module.exports = __webpack_public_path__ + "media/components/resources/svgs/ic_bronze_check-184f4d4cf9735f24b4ad2d41a0d2fcbc.svg";